import React, { useMemo, ReactElement } from 'react';

const FilteredCell: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement | null => {
  const SETTING_NAME_TABLE_COLUMN_SETTINGS: string = 'table-column-settings';

  const {
    columnName,
    tableName,
    currentUser,
    children,
  } = props;

  const tableColumnSettingsCommon: Setting = useMemo((): Setting => (
    currentUser && currentUser.settings
    && currentUser.settings.find((settingItem: Setting): boolean => (
      settingItem.name === SETTING_NAME_TABLE_COLUMN_SETTINGS
    ))
  ), [currentUser]);
  const tableColumnSettings: TableField[] = useMemo((): TableField[] => (
    tableColumnSettingsCommon && tableName && tableColumnSettingsCommon.value
    && tableColumnSettingsCommon.value[tableName]
  ), [tableColumnSettingsCommon, tableName]);
  const columnSettings: TableField | null = useMemo((): TableField | null => (
    columnName && tableColumnSettings && tableColumnSettings.length
      ? ((tableColumnSettings.filter((tableColumnSetting: TableField): boolean => !!tableColumnSetting) as TableField[])
        .find((tableColumnSetting: TableField): boolean => tableColumnSetting.name === columnName) || null) : null
  ), [tableColumnSettings, columnName]);

  if (columnSettings && !columnSettings.isVisible) {
    return null;
  }

  return children;
});

export default FilteredCell;
